import React from 'react'
import "./My_team_details_cards_section.css"
import My_team_details_card from './my_team_details_card/My_team_details_card'

function My_team_details_cards_section() {
    return (
        <>
            <section className='My_team_details_cards_section '>
                <div className="row">
                    <div className="col-sm-6">
                        <My_team_details_card imgSrc="/assets/images/profile/my_team_details_card/img_1.png"/>
                    </div>

                    <div className="col-sm-6">
                        <My_team_details_card imgSrc="/assets/images/profile/my_team_details_card/img_2.png"/>
                    </div>

                    <div className="col-sm-6">
                        <My_team_details_card imgSrc="/assets/images/profile/my_team_details_card/img_3.png"/>
                    </div>

                    <div className="col-sm-6">
                        <My_team_details_card imgSrc="/assets/images/profile/my_team_details_card/img_4.png"/>
                    </div>
                </div>
            </section>
        </>
    )
}

export default My_team_details_cards_section